// Angular
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Router } from '@angular/router';
// AG-Grid
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
    selector: 'cv-custom-name-cell',
    templateUrl: './custom-name-cell.component.html',
    styleUrls: ['./custom-name-cell.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomQueueNameCellComponent implements ICellRendererAngularComp {
    public cellValue: any;
    constructor(private router: Router) {}

    /**
     * When the component renders, it got the possible value
     * @param params
     */
    agInit(params: ICellRendererParams): void {
        if (params.data) {
            this.cellValue = params.data;
        }
    }

    /**
     * Put back the value
     * @param params
     */
    refresh(params: ICellRendererParams): boolean {
        this.cellValue = params;
        return true;
    }

    isRuleId() {
        const isRuleIdPresent = this.cellValue.ruleId ? true : false;
        const isStatusResolved = this.cellValue.status.toUpperCase() == 'RESOLVED';
        return isRuleIdPresent && isStatusResolved;
    }

    /**
     * Opens the rule search with the global rule information.
     */
    openGlobalRule(): void {

    }
}
